export enum ClientType {
    INDIVIDUAL = 1,
    MANAGED = 2,
    UNKNOWN = -1,
}
